export class Option {
  constructor(
    public key: string,
    public value: string,
    public avatar?: string,
    public description?: string,
    public disabled?: boolean
  ) {}
}
